export default __webpack_public_path__ + "static/media/nogroup.645423b0.svg";